import StandardConsentPrompt from './StandardConsentPrompt'

export default StandardConsentPrompt
